/**
 * SBF Design System jQuery Module
 */

'use strict';

import jQuery from 'jquery';

export default jQuery;
